import http from 'utils/http';
import { getCurrentUserUrl, getUserStatusUrl } from './apiUrls';
import { CurrentUserResponse, User } from './types';

export function getCurrentUser(): Promise<CurrentUserResponse> {
  return http.get(getCurrentUserUrl());
}

export function updateCurrentUser(payload: any): Promise<CurrentUserResponse> {
  return http.patch(getCurrentUserUrl(), payload);
}

export function updateUserStatus(id: number, payload: any): Promise<User> {
  return http.patch(getUserStatusUrl(id), payload);
}
